var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('footer', {
    staticClass: "t-footer",
    attrs: {
      "role": "contentinfo"
    }
  }, [_c('ButtonPush', {
    directives: [{
      name: "visible",
      rawName: "v-visible",
      value: _vm.canPagePrevious,
      expression: "canPagePrevious"
    }],
    attrs: {
      "aria-label": "previous page",
      "disabled": !_vm.canPagePrevious,
      "icon": "icon-navwest",
      "spin": "icon-only inline"
    },
    on: {
      "click": _vm.pagePrevious
    }
  }), _c('div', [_vm._v(_vm._s(_vm.logicalPage) + " of " + _vm._s(_vm.lastLogicalPage))]), _c('ButtonPush', {
    directives: [{
      name: "visible",
      rawName: "v-visible",
      value: _vm.canPageNext,
      expression: "canPageNext"
    }],
    attrs: {
      "aria-label": "next page",
      "disabled": !_vm.canPageNext,
      "icon": "icon-naveast",
      "spin": "icon-only inline"
    },
    on: {
      "click": _vm.pageNext
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }